import React, { ReactNode } from "react"
import { ErrorBoundary as SentryErrorBoundary } from "@sentry/react"
import logo from "assets/images/diobox-icon.svg"

// The outermost boundary sits above BrowserRouter, ChakraProvider and
// IntercomProvider, so its fallback must not depend on any of them: plain
// markup, and a full page load instead of a router navigation.
export const RootErrorView = () => (
  <div
    role="alert"
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "1rem",
      height: "100dvh",
      padding: "0 1rem",
      textAlign: "center",
      fontFamily: "proxima-nova, sans-serif",
      color: "#1C1C1C",
    }}
  >
    <img src={logo} alt="" style={{ marginBottom: "0.5rem" }} />
    <h1 style={{
      fontSize: "1.5rem", fontWeight: 600, lineHeight: 1.2, margin: 0,
    }}
    >
      Something went wrong
    </h1>
    <p style={{ fontSize: "1rem", color: "#747474", margin: 0 }}>
      We’ve been notified and will work to quickly resolve.
    </p>
    <div style={{ fontSize: "0.875rem", color: "#9E9E9E", lineHeight: 1.6 }}>
      <p style={{ margin: 0 }}>
        <a href="/" style={{ color: "#3182CE" }}>Reload Diobox</a> and try again.
      </p>
      <p style={{ margin: 0 }}>
        If the error persists, please contact{" "}
        <a href="mailto:support@diobox.com" style={{ color: "#3182CE" }}>support@diobox.com</a>.
      </p>
    </div>
  </div>
)

const RootErrorBoundary = ({ children }: { children: ReactNode }) => (
  <SentryErrorBoundary
    beforeCapture={(scope) => { scope.setTag("boundary", "root") }}
    fallback={<RootErrorView />}
  >
    {children}
  </SentryErrorBoundary>
)

export default RootErrorBoundary
